import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { CutLinesComponent } from '../cut-lines.component';
import { CutLineMode } from '../../../../../models/enum/shared/cut-line-mode.enum';
import { GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER } from '../../../models/grid-column-gap';

@Component({
  selector: 'app-print-card-top-cut-lines',
  templateUrl: './print-card-top-cut-lines.component.html',
  styleUrls: ['./print-card-top-cut-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PrintCardTopCutLinesComponent extends CutLinesComponent {
  // eslint-disable-next-line no-restricted-syntax
  @HostBinding('style.align-items') get alignItems() {
    switch (this.layoutInstructions?.cutLineMode) {
      case CutLineMode.HugPerimeter:
        return 'flex-start';
      case CutLineMode.HugContent:
        return 'flex-end';
      case CutLineMode.Extended:
        return 'stretch';
    }
    return null;
  }

  protected readonly GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER = GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER;
}
